"use strict";

exports.__esModule = true;
exports.default = void 0;

var _progress = require("./progress");

var _progressBar = require("./progress-bar");

var _plugins = require("../../utils/plugins");

var components = {
  BProgress: _progress.default,
  BProgressBar: _progressBar.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/progress/index.js
// module id = 495
// module chunks = 0